import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter, NavLink} from "react-router-dom"
import axios from 'axios'
import { connectNode } from '../../../../utils/global'
import { loadLocationWithMessage } from '../../../../actions/location'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import PostAddIcon from '@material-ui/icons/PostAdd'
import '../../../../styles/assets/css/admin/list1.css'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import Pagination from '../../../functions/pagination'
import { filter_patient_status } from '../variables/patient_1.js'
import Spinner from 'react-spinner-material'
import Graph1 from './graph1'

class DashboardUsageReportEach extends Component {
  constructor() {
      super();
      this.state = {
          dataItems: [], //exampleItems,
          pageOfItems: [],
          data_group: [],
          show_filter_status: 2,
          title: '',
          filter_patient_status: [
            {
              label: 'All status',
              value: 1,
            }, {
              label: 'Active',
              value: 2,
            }, {
              label: 'Active and medication management',
              value: 3,
            },
          ],
      }
      this.onChangePage = this.onChangePage.bind(this)
  }

  componentDidMount() {
    this.getDataList()
    const report_type = this.props.match.params.report_type
    const pid = this.props.match.params.pid
    let title = ''

    if(report_type == 1) {
      title = "Login"
    } else if(report_type == 2) {
      title = "Badges"
    } else if(report_type == 3) {
      title = "Treatment Goals"
    } else if(report_type == 4) {
      title = "Treatment To Do List	"
    } else if(report_type == 5) {
      title = "Graph"
    }

    this.setState ({
      title: title,
    })
  }

  getDataList = () => {
    // Data Group 1 //
    axios({
      method: 'post',
      url: connectNode + 'admin/reports/dashboard_usage_report_each',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: { pid: this.props.match.params.pid }
    })
    .then((result) => {
      console.log(result['data'][0].value)
      this.setState({
        data_group: result['data'][0].value,
      })
    })
  }

  handleChange2 = (e, name) => {
    this.setState({
      [name]: e.target.value
    }, () => {
      this.getDataList()
    })
  }

  onChangePage(pageOfItems) {
    this.setState({ pageOfItems: pageOfItems })
  }

  getDataGroup1 = (data) => {
    var buff_week = 0
    var arr = []
    data.map(each => {
      if(each.num_week >= buff_week) {
        buff_week = each.num_week
        arr.push({
          fullname: each.fullname,
          cnt: each.cnt,
          start_date: this.convertDateFormat2(each.start_date),
          end_date: this.convertDateFormat2(each.end_date),
        })
      }
    })
    return arr
  }

  render() {
    return (<>
      <div className="patient_dashboard box_border4">
        <div className="row">
          <div className="small-12 medium-12 columns headerPage1">
            Dashboard Usage: {this.state.data_group[0]?.fullname}
          </div>
        </div>
        <div className="row">
          {//this.state.data_group.length > 0 &&
          <div className="small-12 columns">
          <table className="table_data1">
            <thead className="table_head">
              <tr>
                <th>Month / Year</th>
                <th>Login</th>
                <th>Badges</th>
                <th>Treatment Goals</th>
                <th>Treatment To Do List</th>
                <th>Graph</th>
              </tr>
            </thead>
          {this.state.data_group.map(each =>
            <tr>
              <td>{each.month_year}</td>
              <td>{each.cnt_login}</td>
              <td>{each.cnt_badges}</td>
              <td>{each.cnt_treatment_goals}</td>
              <td>{each.cnt_treatment_todo_list}</td>
              <td>{each.cnt_graph}</td>
            </tr>)}
          </table>
          </div>}
        </div>
      </div>
    </>)}
}

const mapStateToProps = (state) => {
  //console.log('PatientList STATE: ', state)
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    //console.log('PatientList mapDispatchToProps')
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(DashboardUsageReportEach)
